import router from "./index.js";
import { getLoginInfo } from "@/api/user.js";
import promiseFlat from "@/utils/promiseFlat.js";
import local from "@/utils/storage.js";
import store from "@/store/index.js";

router.beforeEach(async (to, from, next) => {
  if (!local.get("token")) {
    next(to.path === "/login" ? true : "/login");
    return;
  }
  const [err, res] = await promiseFlat(getLoginInfo());
  if (err) {
    local.clear();
    next("/login");
  } else {
    const { permissionList, realName, username } = res;
    store.commit("SET_USER_INFO", {
      permissionList,
      realName,
      username,
    });
    if (to.meta?.permissions?.length) {
      const hasPermission = to.meta?.permissions.every((permissionKey) => {
        return permissionList.includes(permissionKey);
      });
      if (hasPermission) {
        next(true);
      } else {
        next("/home/no-permission");
      }
      return;
    }
    next(true);
  }
});
